import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import type { SiteKind } from '@/types/site';

export function useSite() {
    const page = usePage();

    const site = computed((): SiteKind => page.props.site);

    const siteDisplayName = computed(() => page.props.siteDisplayName);

    const isPdfSite = computed(() => site.value === 'pdf');

    const isImageSite = computed(() => site.value === 'image');

    return { site, siteDisplayName, isPdfSite, isImageSite };
}
